/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import { Random } from "random-js";
import ls from "@/common/localStorage"

var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var cn = ls.getSessionEventCollectionName();
var ClientCollectionName = 'OA_UAT';
const storageRef = con.storageRef
var LeaderBoardGetActions = con.LeaderBoardGetActions
var LeaderBoardSetActions = con.LeaderBoardSetActions
var LeaderBoardClearScore = con.LeaderBoardClearScore
var GetLeaderBoardConfig = con.GetLeaderBoardConfig
var SetLeaderBoardConfig = con.SetLeaderBoardConfig
var LeaderBoardClearItems = con.LeaderBoardClearItems
var LeaderBoardGetAllUsers = con.LeaderBoardGetAllUsers
var LeaderBoardGetAllActions = con.LeaderBoardGetAllActions
var LeaderBoardGetScore = con.LeaderBoardGetScore
var CreateCustomRoomActivity = con.CreateCustomRoomActivity
var LeaderBoardBulkActivity = con.LeaderBoardBulkActivity
var LeaderBoardSetScavenges = con.LeaderBoardSetScavenges
var LeaderBoardGameScores = con.LeaderBoardGameScores
var CreateNewGame = con.CreateNewGame
var ScavengerHuntRef = con.eventDB.collection(cn).doc("Leaderboard").collection("ScavengerHunt");

export default {
  fetchLeaderboards(context) {
    return new Promise((resolve, reject) => {
      let markers = [];
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        }
      }

      axios.post(LeaderBoardGetActions, requestData, { headers: headers }).then(response => {
        if (response.data.status == 0) {
          markers = response.data.results.map(item => {
            item.DisplayLabel = item.DisplayLabel ? item.DisplayLabel : item.ActionName
            return item
          })
          context.commit('SET_LEADERBOARDS', markers)
          resolve(markers);
        }
      });

    });
  },

  updateLeaderboard(context, data) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": [data]
      }

      axios.post(LeaderBoardSetActions, requestData, { headers: headers }).then(response => {
        if (response.status == 200)
          resolve({ status: 200, message: "Data Updated" });
        else
          resolve({ status: 500, message: "Data Not Updated" });
      }).catch(err => { reject(err) });

    });
  },
  exportAllUsers(context) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": {
          "min": 0,
          "max": 9999999999999
        }
      }

      axios.post(LeaderBoardGetAllUsers, requestData, { headers: headers }).then(response => {
        if (response.data.status == 0)
          resolve(response.data.result);
        else
          resolve([]);
      }).catch(err => { reject(err) });

    });
  },
  getUserActions(context, userId) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": {
          "userId": userId,
          "revisionNo": 0
        }
      }

      axios.post(LeaderBoardGetScore, requestData, { headers: headers }).then(response => {
        if (response.data.status == 0)
          resolve(response.data.result);
        else
          resolve([]);
      }).catch(err => { reject(err) });

    });
  },
  exportAllActions(context) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": {
          "min": 0,
          "max": 9999999999999
        }
      }

      axios.post(LeaderBoardGetAllActions, requestData, { headers: headers }).then(response => {
        if (response.data.status == 0)
          resolve(response.data.result);
        else
          resolve([]);
      }).catch(err => { reject(err) });

    });
  },
  getSettings(context, data) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }

      axios.get(`${GetLeaderBoardConfig}?iid=OA_UAT&cid=${Session_Client_Id}&eid=${Session_Event_Id}`, { headers: headers }).then(response => {
        if (response.data.status == 0)
          resolve({ status: 200, data: response.data.results });
        else
          resolve({ status: 500, data: null });
      }).catch(err => { reject(err) });

    });
  },
  setSettings(context, field) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }

      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": {
          "Tabs": field.Tabs,
          "DisplayScoreOnProfile": field.settings.DisplayScoreOnProfile,
          "DisplayScorecardLinkInMyProfile": field.settings.DisplayScorecardLinkInMyProfile
        }
      }

      axios.post(SetLeaderBoardConfig, requestData, { headers: headers }).then(response => {
        if (response.data.status == 0)
          resolve({ status: 200, message: "Data Saved" });
        else
          resolve({ status: 500, message: "Data Not Saved" });
      }).catch(err => { reject(err) });

    });
  },
  clearItems(context, field) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": {
          "type": "user",
          "isClearScore": true,
          "isClearActivity": true,
          "items": field.itemIds
        }
      }

      axios.post(LeaderBoardClearItems, requestData, { headers: headers }).then(response => {
        if (response.status == 200)
          resolve({ status: 200, message: "Data Cleared" });
        else
          resolve({ status: 500, message: "Data Not Cleared" });
      }).catch(err => { reject(err) });

    });
  },
  clearScore(context, data) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
      }

      axios.post(LeaderBoardClearScore, requestData, { headers: headers }).then(response => {
        if (response.status == 200)
          resolve({ status: 200, message: "Data Cleared" });
        else
          resolve({ status: 500, message: "Data Not Cleared" });
      }).catch(err => { reject(err) });

    });
  },
  clearAlltenndeeScore(context, field) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": {
          "type":"action",
          "items":field.items,
          "users":field.users,
          "meta":{"callerIP":"","userAgent":""}
        }
      }

      axios.post(LeaderBoardClearItems, requestData, { headers: headers }).then(response => {
        if (response.data.status == 0)
          resolve({ status: 200, message: "Data Cleared" });
        else
          resolve({ status: 500, message: "Data Not Cleared" });
      }).catch(err => { reject(err) });

    });
  },
  uploadCustomActivity(context, dataArr) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": dataArr
      }

      axios.post(LeaderBoardBulkActivity, requestData, { headers: headers }).then(response => {
        if (response.data.status == 0)
          resolve({ status: 200, message: "Data Added" });
        else
          resolve({ status: 500, message: "Data Not Added" });
      }).catch(err => { reject(err) });

    });
  },
  uploadGameCustomActivity(context, dataArr) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": dataArr
      }

      axios.post(LeaderBoardBulkActivity, requestData, { headers: headers }).then(response => {
        if (response.data.status == 0)
          resolve({ status: 200, message: "Data Added" });
        else
          resolve({ status: 500, message: "Data Not Added" });
      }).catch(err => { reject(err) });

    });
  },
  uploadGameExpoActivity(context, dataArr) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": dataArr
      }

      axios.post(LeaderBoardSetScavenges, requestData, { headers: headers }).then(response => {
        console.log(response)
        if (response.status == 200)
          resolve({ status: 200, message: "Data Added" });
        else
          resolve({ status: 500, message: "Data Not Added" });
      }).catch(err => { reject(err) });

    });
  },
  createCustomActivity(context, field) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }

      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": [{
          "ActionName": field.activityName,
          "ActionScore": Number(field.minimumScore),
          "MaxActionScore": Number(field.maximumScore),
          "IsPublished": field.publishActivity,
        }]
      }

      axios.post(CreateCustomRoomActivity, requestData, { headers: headers }).then(response => {

        if (response.data[0].status == 0)
          resolve({ status: 200, message: "Data Saved" });
        else
          resolve({ status: 500, message: "Data Not Saved" });
      }).catch(err => { reject(err) });

    });
  },
  createNewGame(context, field) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }

      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": [{
          "Name": field.selectedGame,
          "module": field.selectedModule,
          "CollectionPath": 'ExhibitorList/Exhibitors',
          "Score": Number(field.minimumScoreGame),
          "MaxScore": Number(field.maximumScoreGame),
          "IsPublished": true,
          "Meta": {
            "ButtonLabelAfterPlay": field.afterPlayTxt,
            "ButtonLabelBeforePlay": field.beforePlayTxt,
            "GameInfoAfterPlay": field.callToActionMessageTxt,
            "GameInfoBeforePlay": field.callToActionMessageButtonTxt,
            "SuccessMessage": field.successMessageTxt,
          }
        }]
      }

      axios.post(CreateNewGame, requestData, { headers: headers }).then(response => {

        if (response.data[0].status == 0)
          resolve({ status: 200, message: "Data Saved" });
        else
          resolve({ status: 500, message: "Data Not Saved" });
      }).catch(err => { reject(err) });

    });
  },
  fetchGameReport(context, gameid) {
    return new Promise((resolve, reject) => {
      let headers = {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
      }
      let requestData = {
        "key": {
          "eventId": Session_Event_Id,
          "clientId": Session_Client_Id,
          "instanceId": "OA_UAT"
        },
        "data": {
            "min": 0,
            "max": 9999999999999,
            "gameid":gameid
        }
      }

      axios.post(LeaderBoardGameScores, requestData, { headers: headers }).then(response => {
        console.log(response)
        if (response.data.status == 0)
          resolve({'log':response.data.result[0].log[0], 'game_name': response.data.game_name, 'module_path': response.data.module_path});
        else
          resolve({'log':[], 'game_name': null, 'module_path': null});
      }).catch(err => { reject(err) });

    });
  },
  fetchScavengerHunt(context) {
    Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
    return new Promise((resolve, reject) => {
      let markers = []
      ScavengerHuntRef.get().then(querySnapshot => {
        querySnapshot.docs.forEach(doc => {
          let docObj = doc.data();
          docObj.ScavengeId = doc.id;
          markers.push(docObj)
        })
        context.commit('SET_SCAVENGERHUNT', markers)
        resolve(markers)
      }).catch(function (error) {
        reject(error)
      })

    })
  },
}
